





















































































































































import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { InvoiceOutboundModule } from "@/store/modules/invoice-outbound.store";
import { InvoiceInboundModule } from "@/store/modules/invoice-inbound.store";
import InvoiceInboundTable from "@/components/invoice/InvoiceInboundTable.vue";
import InvoiceOutboundTable from "@/components/invoice/InvoiceOutboundTable.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import InvoiceTable from "@/components/invoice/InvoiceTable.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { handleError } from "@/lib/utility/handleError";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";

enum InvoiceTabs {
  ALL,
  INBOUND,
  OUTBOUND
}

@Component({
  components: {
    MIconButton,
    MNoContent,
    MTextField,
    InvoiceTable,
    InvoiceInboundTable,
    InvoiceOutboundTable,
    ConfirmActionDialog
  },
  filters: {}
})
export default class PartnerReportDetailInvoice extends mixins(PermissionMixin) {
  tab = InvoiceTabs.ALL;
  CurrencyEnum = CurrencyEnum;
  readonly formatCurrency = formatCurrency;

  isCostCenterDialogOpen = false;
  isReportLoading = false;

  costCenter = this.report.costCenter ?? this.report.vehicle?.costCenter ?? null;

  get tabs() {
    return Object.keys(InvoiceTabs);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get inbound() {
    return InvoiceInboundModule.filteredAndSorted;
  }

  get outbound() {
    return InvoiceOutboundModule.filteredAndSorted;
  }

  get inboundSubTotalSum() {
    return InvoiceInboundModule.filteredAndSorted.reduce((sum, i) => sum + (i.subTotal || 0), 0);
  }

  get outboundSubTotalSum() {
    return InvoiceOutboundModule.filteredAndSorted.reduce((sum, i) => sum + (i.subTotal || 0), 0);
  }

  get subTotalDiff() {
    return this.outboundSubTotalSum - this.inboundSubTotalSum;
  }

  async updateCostCenter() {
    this.isReportLoading = true;

    try {
      await this.report.updatePartial({ costCenter: this.costCenter });
      this.isCostCenterDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isReportLoading = false;
    }
  }
}
